<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">
        {{ $t("add") }} {{ $t("chargetypes") }}
      </div>
      <!-- charge-types -->
      <router-link class="btn-blue" to="tax-types"
        >{{ $t("chargetypes") }} {{ $tc("list", 2) }}</router-link
      >
    </div>
    <div class="white-wrapper">
      <form>
        <div class="row">
          <div
            v-for="(item, index) in ChargeTypes"
            :key="index"
            v-if="item.fieldname !== 'ct_id'"
            class="col-lg-6 col-xl-3 align-self-center mb-3"
          >
            <div v-if="item.fieldname !== 'ct_is_active'">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <input
                    @focus="onFocusHandler"
                    :type="item.type"
                    :name="item.fieldname"
                    :id="item.fieldname"
                    v-validate="item.validation"
                    v-model="item.fieldvalue"
                    placeholder="."
                    v-b-tooltip.hover.top="$t(item.tooltip)"
                  />
                  <label>{{ $tc(item.label, 1) }}</label>
                </div>
                <!-- <Tooltip :title="$t(item.tooltip)" /> -->
              </div>

              <p v-if="errors.has(item.fieldname)" class="error_message">
                {{ errors.first(`${item.fieldname}`) }}
              </p>
            </div>
            <div v-if="item.fieldname === 'ct_is_active'">
              <div class="d-flex align-items-center">
                <label class="mb-0 mr-3">{{ $t("active") }}</label>
                <!-- <label class="ios-switch"> -->
                <b-form-checkbox
                  type="checkbox"
                  class="j-checkbox"
                  v-model="item.fieldvalue"
                />
                <!-- <span class="switch-slider"></span>
                </label> -->
              </div>
              <p class="error_message mt-0">
                <span></span>
              </p>
            </div>
          </div>
        </div>
        <div class="col-md-12 text-center mt-4">
          <button
            :disabled="btenable"
            class="btn-blue"
            @click.prevent.stop="handleSubmit(true)"
          >
            {{ $t("save") }}
          </button>
          <button
            :disabled="btenable"
            @click.prevent.stop="handleSubmit(false)"
            type="submit"
            class="btn-blue"
          >
            {{ $t("saveaddmore") }}
          </button>
          <button @click.prevent.stop="resetHandler()" class="btn-black">
            {{ $t("reset") }}
          </button>
          <b-button
            class="btn-outline-grey"
            variant="default"
            to="charge-types"
            >{{ $t("cancel") }}</b-button
          >
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import ChargeTypes from "@/helper/formJSONMaster/ChargeTypes";

export default {
  data() {
    return {
      btenable: false,
      ChargeTypes: ChargeTypes.ms_charge_types,
      // v-validate="'required|email'"
      submitted: false,
      Methods: ChargeTypes.Methods,
    };
  },
  mounted() {
    console.log("ChargeTypes :", ChargeTypes);
    this.resetHandler();
  },
  methods: {
    onFocusHandler: function () {
      // this.submitted = false;
    },
    resetHandler: function () {
      this.ChargeTypes.map((x) => {
        if (x.type === "text" || x.type === "date") {
          x.fieldvalue = "";
        } else if (x.type === "radio") {
          x.fieldvalue = true;
        }
      });
    },
    handleSubmit(flag) {
      console.log("call submit :");
      this.submitted = true;
      this.$validator.validate().then((valid) => {
        console.log("valid :", valid);
        if (valid) {
          this.btenable = true;
          // console.log("valid :", valid);
          let body = this.getRequestBody(
            "POST",
            this.ChargeTypes,
            this.Methods
          );
          console.log("body :", body);
          MasterService.GlobalRequest(body)
            .then((response) => {
              this.btenable = false;
              const { data } = response;
              if (data.status) {
                console.log("here :", data);
                if (flag) {
                  this.$router.push({
                    path: "/master/tax-types",
                  });
                } else {
                  this.resetHandler();
                }
              } else {
                this.$toasted.show(data.message);
                console.log("show error1 :", data.message);
              }
            })
            .catch((error) => {
              console.log("show error2 :", error);
            });
        } else {
          console.log("else :");
        }
      });
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/ChargeTypesComponents/addChargeType.vue